module.exports = require("babel-runtime/core-js/number/parse-int");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/number/parse-int"
// module id = 53
// module chunks = 0